<template>
  <div>
    <h2>Perfis de Acesso</h2>

    <v-data-table
      :headers="headers"
      :items="data"
      :page.sync="page"
      :sort-by.sync="sortBy"
      :items-per-page="perPage"
      :loading="isLoading"
      hide-default-footer
      disable-sort
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-text-field 
            v-model="searchFilter.query"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialogForm"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }" v-if="permissions['create_user_roles']">
              <v-btn
                outlined
                color="#0dc4b8" 
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                Novo Perfil
              </v-btn>
            </template>
            <RolesForm :selectedIndex="selectedIndex" :selectedItem="selectedItem" v-on:onClose="closeFormModal" v-on:onSubmit="closeFormModal();loadData()" />
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline center">Deseja realmente excluir {{ selectedItem.name }} ?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#0dc4b8" text @click="closeDeleteModal">Cancelar</v-btn>
                <v-btn color="#0dc4b8" text @click="deleteItemConfirm" :disabled="isLoading || ['Administrador', 'Cliente'].includes(selectedItem.name)" :loading="isLoading">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }" v-if="permissions['edit_user_roles']">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="openEditItemModal(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }" v-if="permissions['delete_user_roles']">
            <v-icon
              small
              @click="openDeleteItemModal(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Excluir</span>
        </v-tooltip>
      </template>

      <template v-slot:footer>
        <div class="table-footer">
          <span class="mr-4" v-if="total>0">Exibindo {{from}} - {{to}} de {{total}} </span>
        </div>
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="totalPages"
      ></v-pagination>
    </div>

  </div>
</template>


<script>
import { mapGetters, mapMutations } from 'vuex'
import UserRolesService from '../../services/user_roles.service';
import RolesForm from './_form.vue';

export default {
  name: 'UserRoles',
  components: {
    RolesForm,
  },
  data: () => ({
    data: [],
    dialogForm: false,
    dialogDelete: false,
    from: 0,
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'Nome', value: 'name' },
    ],
    isLoading: true,
    page: 1,
    permissionOptions: [],
    perPage: 10,
    searchFilter: {
      query: null,
    },
    selectedIndex: -1,
    selectedItem: {
      name: null,
      permissions: [],
    },
    sortBy: 'id',
    to: 0,
    total: 0,
    totalPages: 0,
  }),
  computed: {
    ...mapGetters(['permissions']),
  },
  watch: {
    dialogForm (val) {
      if (val && this.selectedIndex == -1 && this.$refs.form)
        this.$refs.form.resetValidation();
      val || this.closeFormModal()
    },
    dialogDelete (val) {
      val || this.closeDeleteModal()
    },
    page: function () {
      this.loadData();
    },
    searchFilter: {
      handler () {
        this.page = 1;
        this.loadData();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.permissions['edit_user_roles'] || this.permissions['delete_user_roles']) {
      this.headers.push({ text: 'Ações', value: 'actions', sortable: false });
    }

    this.loadData();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    clearForm () {
      this.selectedItem = {
        name: null,
        permissions: [],
      };
      this.selectedIndex = -1;
    },

    closeFormModal () {
      this.dialogForm = false;
      this.$nextTick(() => {
        this.clearForm();
      })
    },

    closeDeleteModal () {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.clearForm();
      })
    },

    deleteItemConfirm () {
      this.isLoading = true;
      UserRolesService.destroy(this.selectedItem.id)
        .then(() => {
          this.data.splice(this.selectedIndex, 1);
          this.to--;
          this.total--;
          this.showSnackbar({ text: "Registro excluído com sucesso!", color:"success" })
        })
        .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
        .finally(() => setTimeout(() => {this.isLoading = false; this.closeDeleteModal();}, 300));
    },

    loadData () {
      this.isLoading = true;

      const params = {
        page: this.page,
        perPage: this.perPage,
        sort: this.sortBy,
      };

      if (this.searchFilter.query) 
        params['filter[name]'] = this.searchFilter.query;

      UserRolesService.get(params)
        .then(({ data }) => {
          const { from, to, total, data: items, current_page } = data;
          this.data = items;
          this.page = current_page;
          this.from = from;
          this.to = to;
          this.total = total;
          this.totalPages = Math.ceil(this.total/this.perPage);
        })
        .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
        .finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    openDeleteItemModal (item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    openEditItemModal (item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = Object.assign({}, item);
      this.dialogForm = true;
    },
  },
}
</script>
